require(['jquery', 'js/glider-min'], function ($) {
const informationSliders = document.querySelectorAll(".js-information-slider");
if (informationSliders) {
	informationSliders.forEach(function (productSlider) {
		let slider = productSlider.querySelector('.slides'),
			slidesToShow = slider.getAttribute('data-slides-to-show'),
			sliderPrev = productSlider.querySelector('.js-information-slider-prev'),
			sliderNext = productSlider.querySelector('.js-information-slider-next'),
			bullets = productSlider.querySelector('.js-information-slider-bullets');

		if (slidesToShow === '0') {
			slidesToShow = '4';
		}

		new Glider(slider, {
			dots: bullets,
			scrollLock: true,
			draggable: true,
			arrows: {
				prev: sliderPrev,
				next: sliderNext
			},
			responsive: [
				{
					breakpoint: 0,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						itemWidth: 'auto'
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2.5,
						slidesToScroll: 2.5,
						itemWidth: 'auto'
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: slidesToShow,
						slidesToScroll: 1,
						itemWidth: 'auto'
					}
				},
			]
		});
	})
}});
